import React, { useContext } from 'react';
import { Button, Card, Hidden, CircularProgress } from '@material-ui/core';
import { AuthStatusContext, retrievePlan } from '@trp-individual-investor-adv-disc/adv-shared';
import BookStarIcon from '../../../images/BookStarIcon';
import './CompletePlan.scss';

const CompletePlan = () => {

    const { applicationConfig } = useContext(AuthStatusContext).state;

    const [isLoading, setIsLoading] = React.useState(false);
    const [hover, setHover] = React.useState(null);
    const onEnter = () => setHover(true);
    const onLeave = () => setHover(false);

    const getPlan = async () => {
        setIsLoading(true);
        await retrievePlan(applicationConfig)
            .finally(() => {
                setIsLoading(false);
            })
    }

    return (
        <Card>
            <div className='complete-plan-container' style={{ display: "flex" }}>
                <div id="icon-container">
                    <Hidden smDown>
                        <BookStarIcon />
                    </Hidden>
                </div>
                <div className='viewPlanContent'>
                    <p className='hubSubHeaderPlanCard'>
                        View Your Complete Plan
                </p>
                    <p className='completePlanDetail'>
                        Want more details? Check here for your comprehensive plan, including our analysis and methodology.
                </p>
                    <Button
                        variant="outlined"
                        style={{ display: 'block', marginTop: '32px' }}
                        onClick={() => getPlan()}
                        onMouseEnter={onEnter}
                        onMouseLeave={onLeave}
                    >
                        View Plan {' '}
                        {isLoading && React.cloneElement(
                            <CircularProgress
                                size={20}
                                id='loading-spinner'
                                style={{
                                    color: '#05C3DE',
                                    marginLeft: '16px',
                                    verticalAlign: 'sub'
                                }}
                            /> , { filled: !!hover })}
                    </Button>
                </div>
            </div>
        </Card>
    )
}

export default CompletePlan;
